import React from 'react';
import {useLocation} from 'wouter';

import {DeleteStatusNotification} from '../../../../../../providers/notifications-center/notifications/delete';
import {useDeleteDocumentMutation} from '../../../hooks/use-delete-document-mutation';
import {showNotification} from '../../../../../../providers/notifications-center/show-notification';

interface Props {
    accession: string;
    children: React.ReactElement<{onClick: () => Promise<void>}>;
}

/**
 * Component allowing to Delete a document
 */
export function DeleteItem(props: Props) {
    const [, navigate] = useLocation();
    const deleteMutation = useDeleteDocumentMutation();

    const handleDelete = async () => {
        try {
            await deleteMutation.mutateAsync(props.accession);

            showNotification(<DeleteStatusNotification />);
            navigate('/');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            showNotification(<DeleteStatusNotification isError errorMessage={error.message} />);
        }
    };

    return React.cloneElement(props.children, {onClick: handleDelete});
}
